import { loadableWithFallback } from '@vision/ui/utils';
import type { BarChart4Props } from './BarChart4';

export const BarChart4 = loadableWithFallback<BarChart4Props>(() => import('./BarChart4'));
